import type messageZh from '../zh/message';

const message: typeof messageZh = {
  qr_sample: 'The sample has been shipped, please watch for it',
  qr_video: 'Please let me know after the video is published',
  qr_commission: 'Commission is negotiable',
  qr_thanks: 'Thanks for collaborating',
  load_failed: 'Failed to load conversations',
  pending_reply_failed: 'Could not load the unreplied count',
  message_load_failed: 'Failed to load messages',
  archived_toast: 'Conversation archived. Find it under Archived',
  restored_toast: 'Conversation restored to the inbox',
  starred_toast: 'Added to starred',
  unstarred_toast: 'Removed from starred',
  star_failed: 'Could not update the star',
  archive_failed: 'Could not update the archive',
  mark_read: 'Mark as read',
  marked_read: 'Marked as read',
  mark_read_failed: 'Could not mark the conversation as read',
  offline: 'Offline',
  starred: 'Starred',
  star: 'Star',
  view_profile: 'View profile',
  profile_missing: 'No creator profile yet',
  title: 'Direct messages',
  refresh_failed: 'Refresh failed',
  history_failed: 'Failed to load earlier messages',
  template_soon: 'Script templates are coming soon',
  empty: 'No messages yet. Say hello',
  profile_title: 'Creator profile',
  inbox: 'Inbox',
  broadcast: 'Broadcast tasks',
  quota_tip: 'Up to {{limit}} messages before the creator replies',
  today_quota: 'Remaining quota',
  quota_shop_label: 'Shops',
  quota_mail_label: 'Email',
  quota_unlimited: 'Unlimited',
  quota_shop_detail: 'Shops left {{remaining}} / {{total}}, plan {{plan}}, add-on {{addon}}, used {{used}}',
  quota_mail_detail: 'Email left {{remaining}} / {{total}}, plan {{plan}}, add-on {{addon}}, used {{used}}',
  quota_mail_unlimited_detail: 'Unlimited email, plan {{plan}}, add-on {{addon}}, used {{used}}',
  quota_reset: 'Plan quota until {{time}}',
  quota_load_failed: 'Could not load quota',
  create_broadcast: 'Create broadcast',
  filter_all: 'All',
  unread: 'Unread',
  unreplied: 'Unreplied',
  archived: 'Archived',
  refresh: 'Refresh',
  mark_all_read: 'Mark all as read',
  more: 'More',
  search_placeholder: 'Search creators / messages',
  no_match: 'No matching conversations',
  empty_inbox: 'No conversations yet',
  tiktok_talent: 'TikTok creator',
  tiktok_dm: 'TikTok DM',
  location: 'Location',
  session_messages: 'Messages',
  message_count: '{{count}}',
  last_message: 'Latest message',
  session_status: 'Status',
  pending: 'Awaiting reply',
  unbound_hint: 'This creator is not bound to the shop yet. Invite them to bind and build a long-term collaboration.',
  start_invite: 'Create targeted invitation',
  send_bind: 'Send bind invite',
  view_homepage: 'View profile page',
  restore: 'Restore conversation',
  archive: 'Archive conversation',
  hidden_product: 'Hidden',
  col_task: 'Task',
  col_progress: 'Progress',
  col_status: 'Status',
  col_reply: 'Replies',
  col_product: 'Product card',
  col_actions: 'Actions',
  task_total: '{{count}} total',
  list_hint:
    'Broadcasts go through the task queue and replies land in Inbox. Blacklisted, contacted in the last 7 days, and unsubscribed creators are removed before sending.',
  detail_title: 'Broadcast · {{name}}',
  reply_rate: 'Reply rate',
  created_at: 'Created',
  status_sending: 'Sending',
  status_queued: 'Queued',
  status_done: 'Done',
  status_paused: 'Paused',
  campaign_QUEUED: 'Queued',
  campaign_SENDING: 'Sending',
  campaign_COMPLETED: 'Completed',
  campaign_PARTIAL_FAILED: 'Partially failed',
  campaign_CANCELLED: 'Cancelled',
  campaign_load_failed: 'Could not load broadcast tasks',
  success_count: 'Delivered',
  fail_count: 'Failed',
  reply_count: 'Replied',
  name_fallback: 'Broadcast',
  quota_warn: 'Created. {{count}} left in today’s quota; the rest will send tomorrow',
  created: 'Broadcast created. {{count}} creators are in the send queue',
  create_title: 'Create DM broadcast',
  task_name: 'Task name',
  task_name_placeholder: 'Enter a task name',
  task_name_required: 'Please enter a task name',
  body_required: 'Please enter the message',
  send_body: 'Message',
  template_placeholder: 'Select a script',
  template_empty: 'This shop has no DM scripts',
  product_empty: 'This shop has no products to attach',
  product_id: 'Product ID',
  product_id_placeholder: 'Enter a product ID',
  product_id_required: 'Please enter a product ID',
  create_failed: 'Could not create the broadcast',
  create: 'Create',
  selected_skip: '{{count}} creators selected. Blacklist and creators contacted in the last 7 days are removed before sending',
  show_product: 'Show product card',
  pick_product_card: 'Select product card ({{shop}})',
  price_rate: '{{price}} · Commission {{rate}}%',
  queue_hint: 'Broadcasts enter the task queue and are sent later. Replies go to Inbox.',
  preview_image: '[Image]',
  preview_file: '[File] {{name}}',
  blocked_archived: 'This conversation is archived. Restore it to send again',
  blocked_quota: 'Today’s DM quota is used up ({{limit}}). It resets at 00:00',
  blocked_limit: 'You can send at most {{limit}} messages before they reply. Sent {{sent}}/{{limit}}. Please wait for the creator',
  send_unavailable: 'Sending messages is not connected yet',
  send_failed: 'Could not send the message',
  send_success: 'Message sent'
};

export default message;
